import {useEffect} from 'react';
import {SingleCompetitor} from './SingleCompetitor/SingleCompetitor';
import styles from './style.module.scss';
import css from '../../index.module.scss';
import {Typography, Spin, Select, Tooltip} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons';
import {observer} from 'mobx-react';
import {useStore} from '@/store/root-store';
// import {NextImg} from '@/utils/nextImg';

export const TopRankingCompetitors = observer(() => {
  const {
    contentOptimizer: {
      currentPage,
    }} = useStore('');

  const {Option} = Select;
  const {Title} = Typography;
  const antIcon = <LoadingOutlined style={{fontSize: 16, color: '#7f4ead', marginLeft: '10px'}} spin />;


  // used for default setup + adding keywords
  useEffect(() => {
    if (currentPage?.topRankingCompetitorActiveKw && currentPage?.analytics?.competitorsData?.length && currentPage?.analytics?.competitorsData.find(item => item.keyword == currentPage?.topRankingCompetitorActiveKw)) {
      currentPage?.setTopRankingCompetitorsActiveKw(currentPage?.topRankingCompetitorActiveKw);
    } else if (currentPage?.analytics?.competitorsData && currentPage?.analytics?.competitorsData[0]) {
      currentPage?.setTopRankingCompetitorsActiveKw(currentPage?.analytics?.competitorsData[0]?.keyword);
    } else {
      currentPage?.setTopRankingCompetitorsActiveKw('');
    }
  }, [[...(currentPage?.analytics?.competitorsData ?? '')], currentPage?.analytics?.competitorsData?.length]);


  const handleOnSortChange = value => {
    currentPage?.setTopRankingCompetitorsActiveKw(value);
  };


  return <div style={{marginBottom: 50}}>
    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 20}}>
      <Title className={css.subTitle} level={4} style={{marginRight: '10px', fontSize: 14, fontWeight: 500, textTransform: 'capitalize', marginTop: 5}}>
        Top Ranking Competitors {currentPage?.isAnalyzing && <Spin indicator={antIcon} style={{marginRight: '20px'}}/>}
      </Title>
      <div style={{cursor: 'pointer', color: '#34AEF3'}} onClick={() => currentPage.openCompetingFocusTermsDrawer()}>
        Analyse Content
      </div>
    </div>

    {currentPage?.analytics?.competitorsData?.length ? <div className={styles.competitorsContainer}>
      <Tooltip title={currentPage?.topRankingCompetitorActiveKw} placement='left'>
        <Select
          value={`Keyword: ${currentPage?.topRankingCompetitorActiveKw}`}
          defaultValue={currentPage?.topRankingCompetitorActiveKw || ''}
          onSelect={value => handleOnSortChange(value)}
          dropdownStyle={{minWidth: '150px', fontSize: '12px'}}
          dropdownClassName={styles.keywordDropdownList}
          className={styles.selectInput}
          suffixIcon={<FontAwesomeIcon icon={faCaretDown} style={{color: '#fff', width: 8}}/>}
        >
          {currentPage?.analytics?.competitorsData?.map(item => {
            return <Option title='' key={item.keyword} value={item.keyword}>{item.keyword}</Option>;
          })}

        </Select>
      </Tooltip>
      <div className={styles.competitorsInnerContainer}>
        {currentPage?.analytics?.competitorsData?.filter(item => item.keyword === currentPage?.topRankingCompetitorActiveKw)[0]?.competitors?.map(competitor => {
          return competitor?.title && <SingleCompetitor competitor={competitor} loading={currentPage?.isAnalyzing}/>;
        })}
      </div>
    </div> :
      !currentPage?.content?.targetKeywords?.length ? <div className={styles.emptyDataBox}>
        {/* <div className={styles.emptyImg}><NextImg src='/img/icon/Vector-checked.svg' /></div> */}
        <span className={styles.emptyDataTitle}>{currentPage?.isAnalyzing ? 'Loading Top Ranking Competitors...': 'Please add Target Keywords to view the Top Ranking Competitors.'}</span>
      </div> : <div className={styles.emptyDataBox}>
        {/* <div className={styles.emptyImg}><NextImg src='/img/icon/Vector-checked.svg' /></div> */}
        <span className={styles.emptyDataTitle}>{currentPage?.isAnalyzing ? 'Loading Top Ranking Competitors...': 'No Competitors found for these Target Keywords.'}</span>
      </div> }
  </div>;
});
